import { render, staticRenderFns } from "./nps-feedback.vue?vue&type=template&id=9d9bf1ac&scoped=true"
import script from "./nps-feedback.vue?vue&type=script&lang=ts"
export * from "./nps-feedback.vue?vue&type=script&lang=ts"
import style0 from "./nps-feedback.vue?vue&type=style&index=0&id=9d9bf1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9bf1ac",
  null
  
)

export default component.exports